import './App.scss';
import { TubeList } from "./components/TubeList/TubeList";
import { Footer } from "./components/Footer/Footer";
import { GigList } from './components/GigList/GigList';
import { HeroVideo } from './components/HeroVideo/HeroVideo';
import { StoreList } from './components/StoreList/StoreList';
function App() {
  return (
    <div className="App">
      <HeroVideo />
      <TubeList />
      <GigList />
      <StoreList />
      <Footer />
    </div>
  );
}

export default App;
